import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { EmpathySection } from './components/EmpathySection';
import { VisionSection } from './components/VisionSection';
import { AuthorSection } from './components/AuthorSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { FeaturesSection } from './components/FeaturesSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
const META_PIXEL_ID = '1744921309871699';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel base code
    if (typeof window === 'undefined') return;
    if (!window.fbq) {
      const f: any = window;
      const n: any = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod ?
        // eslint-disable-next-line prefer-rest-params
        n.callMethod.apply(n, arguments as any) :
        // eslint-disable-next-line prefer-rest-params
        n.queue.push(arguments);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) {
        target.appendChild(script);
      }
      window.fbq?.('init', META_PIXEL_ID);
    }
    // Fire PageView
    window.fbq?.('track', 'PageView');
    // Fire ViewContent shortly after page load
    const viewContentTimer = window.setTimeout(() => {
      window.fbq?.('track', 'ViewContent', {
        content_name: 'Historias infantiles para dormir en paz',
        content_type: 'product',
        value: 12990,
        currency: 'ARS'
      });
    }, 1500);
    return () => {
      window.clearTimeout(viewContentTimer);
    };
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
      <main className="flex-grow" data-id="element-3">
        <Hero data-id="element-4" />
        <EmpathySection data-id="element-5" />
        <VisionSection data-id="element-6" />
        <AuthorSection data-id="element-7" />
        <BenefitsGrid data-id="element-8" />
        <FeaturesSection data-id="element-9" />
        <Testimonials data-id="element-10" />
        <OfferSection data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <RecentPurchaseToast data-id="element-15" />
    </div>;
}